import useGetNewspaperWebConfig from './useGetNewspaperWebConfig'
export default useGetNewspaperWebConfig
